import type { track as TrackType } from "pro-features/components/WithTrack/src/context";
import { allTrackers } from "app/services/track/track";

export type SetupTrackingEntity = {
    trackResentsOpen(): void;
    trackRecentSelect(): void;
    trackStart(website: string): void;
    trackCreate(customAttributes: Record<string, string>): void;
    trackCancel(): void;
    trackWebsiteFocus(): void;
    trackSelectionOfWebsite(website: string): void;
    trackUpgradePackageClick(location: string): void;
    trackError(): void;
    trackSelectSharedActivation(): void;
    trackAIRefineMessageManuallyType(prompt: string): void;
    trackAIRefineMessageSuggestionClick(prompt: string): void;
    trackAddCompetitorClick(competitor: string, selectedCompetitorsLength: number): void;
    trackRemoveCompetitorClick(competitor: string, selectedCompetitorsLength: number): void;
    trackAddCompetitorManually(competitor: string, selectedCompetitorsLength: number): void;
    trackCancelSetup(step: string): void;
    trackOffSubscriptionSwitcher(): void;
    trackOnSubscriptionSwitcher(): void;
};

const createSetupTracking = (track: TrackType): SetupTrackingEntity => ({
    trackResentsOpen() {
        track("recent websites", "open", "");
    },
    trackRecentSelect() {
        track("recent websites", "select", "");
    },
    trackStart(website: string) {
        track("Button", "click", "continue to select competitors", { selected_website: website });
    },
    trackError() {
        track("Button", "click", "error in website selection");
    },
    trackCreate(customAttributes: Record<string, string>) {
        track("competitive set", "create", "competitive set/created", customAttributes);
    },
    trackCancel() {
        track("Button", "click", "cancel/click");
    },
    trackWebsiteFocus() {
        track("Input", "focus", "main website/input");
    },
    trackSelectionOfWebsite(website: string) {
        track("Input", "select website", "main website/input", { selected_website: website });
    },
    trackUpgradePackageClick(location: string) {
        track("Internal Link", "click", `TrialBanner/${location}`);
    },
    trackSelectSharedActivation() {
        track("Button", "click", "Select project/Projects list empty state");
    },
    trackAIRefineMessageManuallyType(prompt) {
        track("Button", "click", `refine competitors/${prompt}`);
    },

    trackAIRefineMessageSuggestionClick(prompt) {
        track("Button", "click", `select suggested refinement/${prompt}`);
    },
    trackAddCompetitorClick(competitor, selectedCompetitorsLength) {
        track("Button", "click", `select competitor/${competitor}/${selectedCompetitorsLength}`);
    },
    trackRemoveCompetitorClick(competitor, selectedCompetitorsLength) {
        track("Button", "click", `remove competitor/${competitor}/${selectedCompetitorsLength}`);
    },
    trackAddCompetitorManually(competitor, selectedCompetitorsLength) {
        track("Button", "click", `add competitor manually/${competitor}/${selectedCompetitorsLength}`);
    },
    trackCancelSetup(step) {
        track("Button", "click", `cancel setup/${step}`);
    },
    trackOffSubscriptionSwitcher() {
        track("Button", "off", "digest settings/subscription");
    },
    trackOnSubscriptionSwitcher() {
        track("Button", "on", "digest settings/subscription");
    },
});

export default createSetupTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
